class PimoroniProductList extends HTMLElementPlus {
  init() {
    // fill with twelve dummy 'shadow' entries
    this.innerHTML = `<article class="dummy"><div></div></article>`.repeat(12)

    this.client = algoliasearch("M00M3RFW1A", "73a374afec1531d4ea65286681ba81a6")
    this.requestId = 0

    this.pages = 0
    this.page = 1
    this.hits = []
    this.hitCount = 0
  }

  loadURL(usp) {
    this.tag          = usp.get("tag")
    this.productType  = usp.get("product_type")
    this.special      = usp.get("special")
    this.region       = usp.get("region")
    this.colour       = usp.get("colour")
    this.query        = usp.get("query")
    this.sort         = usp.get("sort") || ""
    this.page         = usp.get("page") || 1
    this.search()
  }

  getURL() {
    const usp = new URLSearchParams()
    if(this.tag) usp.set("tag", this.tag)
    if(this.productType) usp.set("product_type", this.productType)
    if(this.special) usp.set("special", this.special)
    if(this.region) usp.set("region", this.region)
    if(this.colour) usp.set("colour", this.colour)
    if(this.query) usp.set("query", this.query)
    if(this.sort) usp.set("sort", this.sort)
    if(this.page && this.page != 1)         usp.set("page",         this.page)
    return usp

  }

  urlChanged() {
    $(this).trigger("urlchange", [this.getURL()])
    this.search()
  }


  search(noPushState = false) {     
    let indexName = "wholesale.pimoroni.com.variants"
    if(this.sort == "popularity") {indexName += ".sort-popularity"}
    if(this.sort == "price")      {indexName += ".sort-price"}
    if(this.sort == "new")        {indexName += ".sort-new"}
    if(this.sort == "hot")        {indexName += ".sort-hot"}    

    let facetFilters = []
    let fixedFacetFilters = []

    if(this.inStockOnly == "true") {
      facetFilters.push(["in_stock:true"])
      fixedFacetFilters.push(["in_stock:true"])
    }

    if(this.collection) {
      facetFilters.push(["collections:" + this.collection])
      fixedFacetFilters.push(["collections:" + this.collection])
    }

    if(this.productType) {
      facetFilters.push(["product_type:" + this.productType])
      fixedFacetFilters.push(["retired:false"])
    }

    if(this.includeRetired != "true") {
      facetFilters.push(["retired:false"])
      fixedFacetFilters.push(["retired:false"])
    }    

    let allFacetFilters = facetFilters.slice() // clone filter array
    if(this.tag) {
      allFacetFilters.push(["tags:" + this.tag])
    }
    if(this.colour) {
      allFacetFilters.push(["colour:" + this.colour])
    }
    if(this.region) {
      allFacetFilters.push(["option.region:" + this.region])
    }
    if(this.special) {
      allFacetFilters.push(["special:" + this.special])
      fixedFacetFilters.push(["special:" + this.special])
    }

    if(this.skus != undefined) {
      allFacetFilters.push(this.skus.split(",").map(v => `sku:${v}`)) 
    }

    let hitCount = this.perPage || 48

    let queries = [
      // query to get hits based on the users current search and filters
      {indexName: indexName, query: this.query || "", params: {facetFilters: allFacetFilters, hitsPerPage: hitCount, page: this.page - 1}},
      // query to get the tag facets
      {indexName: indexName, query: this.query || "", params: {facetFilters: facetFilters, hitsPerPage: 0, maxValuesPerFacet: 100, sortFacetValuesBy: "alpha", facets: ["special", "tags", "colour", "option.region"]}},
      // query to get facets ignoring the users current filters
      {indexName: indexName, query: this.query || "", params: {facetFilters: fixedFacetFilters, hitsPerPage: 0, maxValuesPerFacet: 100, sortFacetValuesBy: "alpha", facets: ["tags", "product_type", "vendor"]}}
    ]

    var checkRequestId = ++this.requestId
    console.log(queries)
    this.client.multipleQueries(queries).then(({results}) => {      
      if(checkRequestId != this.requestId) {return} // ensure that out of order responses are discarded

      // update control state to reflect latest seaerch
      this.page = results[0].page + 1
      this.pages = results[0].nbPages
      this.hits = results[0].hits
      this.hitCount = results[2].nbHits
      this.facets = results[2].facets
      this.subFacets = results[1].facets

      // build the search results
      if(results[0].page == 0) {
        this.innerHTML = ""
      }

      for(let hit of this.hits) {
        let itemHTML = window[this.templateFunction](hit)
        this.insertAdjacentHTML("beforeend", itemHTML)
      }

      const event = new Event("updated")
      this.dispatchEvent(event)
    })  
  }

  collectionChanged()   {this.urlChanged()}
  tagChanged()          {this.urlChanged()}
  productTypeChanged()  {this.urlChanged()}
  specialChanged()      {this.urlChanged()}
  regionChanged()       {this.urlChanged()}
  colourChanged()       {this.urlChanged()}
  queryChanged()        {this.urlChanged()}
  sortChanged()         {this.urlChanged()}
  pageChanged()         {this.urlChanged()}
}
customElements.define("p-product-list", PimoroniProductList)

class PimoroniProductListTypeFilter extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]
    this.list = $("<ul>")
    $(this).append(this.list)

    $(this.productList).on("updated", (e) => {
      this.list.empty()
      this.addItem("All", this.productList.hitCount)
      let facets = this.productList.facets.product_type
      for(let facet in facets) {
        let count = facets[facet]
        if(this.productList.hitCount != count)
        this.addItem(facet, count)
      }      
    })            
  }

  addItem(name, count) {
    let listItem = $(`<li>${name} <small>(${count})</small></li>`)
    listItem.toggleClass("active", name == this.productList.productType || (name == "All" && !this.productList.productType))
    if(name == this.productList.productType) {      
      if(this.productList.subFacets.tags) {
        let tagList = $(`<ul>`)
        for(let tag in this.productList.subFacets.tags) {
          let tagCount = this.productList.subFacets.tags[tag]          
          if(tag != name && tagCount != count) {             
            let tagListItem = $(`<li>${tag} <small>(${tagCount})</small></li>`)          
            tagListItem.toggleClass("active", tag == this.productList.tag)
            tagList.append(tagListItem)
            tagListItem.click((e) => {
              
              if(tag == this.productList.tag) {
                $(this.productList).removeAttr("tag")
              }else{
                $(this.productList).attr("tag", tag)
                $(this.productList).removeAttr("colour")                
                $(this.productList).removeAttr("region")                
              }
              return false
            })
          }
        }
        if(tagList.children().length > 0) {
          listItem.append(tagList)
        }        
      }
    }
    listItem.click((e) => {
      $(this.productList).removeAttr("tag")
      if(name == "All" || name == this.productList.productType) {
        $(this.productList).removeAttr("product-type")
      }else{
        $(this.productList).attr("product-type", name)
        $(this.productList).removeAttr("colour")                
        $(this.productList).removeAttr("region")                
      }      
    }) 
    this.list.append(listItem)
  }

  productListChanged() {}
}
customElements.define("p-product-list-type-filter", PimoroniProductListTypeFilter)

class PimoroniProductListSpecialFilter extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]
    this.list = $("<ul>")
    $(this).append(this.list)

    $(this.productList).on("updated", (e) => {
      let specialFacets = this.productList.subFacets.special
      this.list.empty()      
      
      for(let facet in specialFacets) {
        this.addItem(facet, specialFacets[facet])          
      } 
      $(this).parent().toggle(this.list.children().length > 0)
    })            
  }

  addItem(name, count) {
    let listItem = $(`<li><label><input type="checkbox" /> ${name} <small>(${count})</small></label></li>`)
    listItem.find("input").prop("checked", name == this.productList.special)
    listItem.find("input").change((e) => {
      if($(e.target).prop("checked")) {
        $(this.productList).attr("special", name)
      }else{
        $(this.productList).removeAttr("special")  
      }      
    })
    this.list.append(listItem)
  }

  productListChanged() {}
}
customElements.define("p-product-list-special-filter", PimoroniProductListSpecialFilter)


class PimoroniProductListColourFilter extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]

    this.innerHTML = `<ul></ul>`

    // whenever search results are updated rebuild the colour list
    $(this.productList).on("updated", (e) => {
      try {
        $(this).children("ul").empty()
        let facets = Object.keys(this.productList.subFacets.colour).sort()
        for(var facet of facets) {
          $(this).children("ul").append(
            $(`<li>`)
            .attr("title", titleCase(facet))
            .attr("value", facet)
            .addClass(facet)
            .toggleClass("active", facet == this.productList.colour)
          )          
        }

        // setup click handler for list items
        $(this).find("li").click((e) => {
          if($(e.target).hasClass("active")) {
            $(e.target).removeClass("active")  
            $(this.productList).removeAttr("colour")  
          }else{
            $(e.target).siblings().removeClass("active")
            $(e.target).addClass("active")  
            $(this.productList).attr("colour", $(e.target).attr("value"))
          }
        })
    
        $(this).parent().show()
      } catch {
        $(this).parent().hide()
      }
    })                
  }

  productListChanged() {}
}
customElements.define("p-product-list-colour-filter", PimoroniProductListColourFilter)


class PimoroniProductListRegionFilter extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]

    this.innerHTML = `<ul></ul>`

    // whenever search results are updated rebuild the colour list
    $(this.productList).on("updated", (e) => {
      try {
        $(this).children("ul").empty()
        let facets = Object.keys(this.productList.subFacets["option.region"]).sort()
        for(var facet of facets) {
          let listItem = $(`<li><label><input type="checkbox" /> ${facet}</label></li>`)
          listItem.find("input").prop("checked", facet == this.productList.region)
          listItem.find("input").attr("value", facet)
          $(this).children("ul").append(listItem)          
        }

        // setup click handler for list items
        $(this).find("input").change((e) => {
          if($(e.target).prop("checked")) {
            $(this.productList).attr("region", $(e.target).attr("value"))
          }else{
            $(this.productList).removeAttr("region")   
          }
        })
    
        $(this).parent().show()
      } catch {
        $(this).parent().hide()
      }
    })                
  }

  productListChanged() {}
}
customElements.define("p-product-list-region-filter", PimoroniProductListRegionFilter)

class PimoroniProductListSubQuery extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]

    let placeholder = this.placeholder || "Search within…"
    this.innerHTML = `
      <input type="text" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="${ placeholder }">
      <button type="submit" aria-label="Search within…">
        <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 24 24" fill="var(--grey)"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
      </button>`

    $(this).find("input").on("input", (e) => {
      let query = $(e.target).val()
      if(query) {
        $(this.productList).attr("query", query)
      }else{
        $(this.productList).removeAttr("query")  
      }      
    })
  }

  productListChanged() {}
}
customElements.define("p-product-list-sub-query", PimoroniProductListSubQuery)

class PimoroniProductListSort extends HTMLElementPlus {
  init() {    
    this.productList = $(`#${this.productList}`)[0]

    this.innerHTML = `
      <a href="#" value="" class="active">Featured</a>
      <a href="#" value="new">Newest</a>
      <a href="#" value="popularity">Popularity</a>
      <a href="#" value="price">Price</a>
      `

    $(this).children("a").click((e) => {
      $(e.target).siblings().removeClass("active")
      $(e.target).addClass("active")
      $(this.productList).attr("sort", $(e.target).attr("value"))      
      return false
    })    
  }

  productListChanged() {}
}
customElements.define("p-product-list-sort", PimoroniProductListSort)






/* ========================================================================
   Helper functions
   ======================================================================== */
getVariantSearchRecord = async (sku) => {
  let client = algoliasearch("M00M3RFW1A", "73a374afec1531d4ea65286681ba81a6")
  let index = client.initIndex("wholesale.pimoroni.com.variants")
  let hits = await index.search("", {facetFilters: [[`sku:${sku}`]], hitsPerPage: 1})
  return hits.hits[0] || null
}
